import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import WidgetApp from "@/WidgetApp";

const isWidget = window.location.pathname === '/widget' || window.location.search.includes('mode=widget');

// Apply saved theme
const savedTheme = localStorage.getItem('hc-theme');
if (savedTheme !== 'light') document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isWidget ? <WidgetApp /> : <App />}
  </React.StrictMode>,
);
